<script>
import TwCard from '@/components/generic/tw-card.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import TwContainerFullWidth from '../../generic/tw-container-full-width.vue'
import FundraiserPagePublishButton from '@/components/fundraiser-pages/fundraiser-page-publish-button.vue'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import { useAuthStore } from '@/stores/auth.js'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import TwModal from '@/components/generic/modal/tw-modal.vue'
import FundraiserSocialsShare from '@/components/fundraisers/fundraiser-socials-share.vue'

export default {
  name: 'FundraiserPageTopHeader',
  components: { TwModal, FundraiserSocialsShare, TwButton, TwBadge, FundraiserPagePublishButton, TwContainerFullWidth, TwTransitionContainer, TwCard },
  props: {
    fundraiserPage: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentUser() {
      return useAuthStore().currentUser
    },
    fundraiserPageEditableByCurrentUser(){
      return !!(this.fundraiserPage.published && this.currentUser && (this.currentUser.id === this.fundraiserPage.owner_user_id || this.currentUser.admin || (this.fundraiser && this.fundraiser.owner_user_id === this.currentUser.id)))
    },
    fundraiser() {
      return useFundraiserPublicStore().getItemById(this.fundraiserPage.fundraiser_id)
    }
  },
  methods: { useFundraiserPagePublicStore }
}
</script>

<template>
  <div class="bg-white py-3">
    <div v-if="currentUser && (currentUser.id === fundraiserPage.owner_user_id || currentUser.admin)" class="-mt-3">
      <div v-if="!fundraiserPage.published" class="rounded-lg p-4 bg-amber-100 mb-3 text-center w-full">
        <p class="text-sm">
          This fundraiser has not been published. It will not be visible to the public until you publish it. Only you can see it for now.
        </p>
      </div>
      <div v-else-if="fundraiserPage.published" class="p-4 bg-green-100 mb-3 text-center w-full text-xs sm:text-sm">
        <span>This fundraiser is LIVE. Now is a great time to promote your cause by
          <router-link :to="{name: 'FundraiserPageCommunicationsPage', params: { fundraiserPageId: fundraiserPage.id }, hash: '#emailcampaign' }" class="underline font-medium" target="_blank">creating an email campaign</router-link>
          or
          <tw-button variant="link" class="text-xs sm:text-sm font-medium underline" @click="$refs.shareModal.open()">sharing your page.</tw-button>
        </span>
      </div>
      <tw-modal ref="shareModal" ok-only ok-text="Close" variant="secondary" title="Share this fundraiser" @ok="$refs.shareModal.close()">
        <fundraiser-socials-share :fundraiser="fundraiserPage" />
      </tw-modal>
    </div>
    <tw-container-full-width class="max-w-[1360px]">
      <tw-transition-container />
      <div class="flex flex-col sm:flex-row-reverse justify-between items-center gap-4">
        <div v-if="currentUser" class="flex flex-col sm:flex-row-reverse gap-3 w-full sm:w-auto">
          <fundraiser-page-publish-button v-if="!fundraiserPage.published" :fundraiser-page="fundraiserPage" size="sm" @published="useFundraiserPagePublicStore().itemPatchState($event)" />
          <tw-button icon="pencil" :to="{name: 'FundraiserPageDetailsPage', params: {fundraiserPageId: fundraiserPage.id} }" variant="light" size="sm">
            Edit Fundraiser
          </tw-button>
          <div v-if="fundraiser && fundraiser.settings.teams_enabled" class="text-sm pt-2">
            <span v-if="fundraiserPage.belongs_to_team_id"> You are currently fundraising with team <strong v-if="fundraiserPage.cached.team_name">{{ fundraiserPage.cached.team_name }}</strong> </span>
            <span v-else>
              You are currently not fundraising with a team. Click <router-link class="font-bold" :to="{name: 'FundraiserPageDetailsPage', params: {fundraiserPageId: fundraiserPage.id} }">Edit page</router-link> to join a team
            </span>
          </div>
        </div>
        <tw-button v-if="!currentUser" :to="{name: 'Login'}" variant="link" class="absolute right-4 top-4 sm:relative sm:top-0 sm:right-0">
          Login
        </tw-button>
        <div v-if="currentUser && currentUser.id !== fundraiserPage.owner_user_id ">
&nbsp;
        </div>
        <div v-if="fundraiserPage.logo_url && fundraiserPage">
          <router-link :to="{name: 'FundraiserPublicPage', params: {fundraiserId: fundraiserPage.fundraiser_id, slug: fundraiserPage.slug}}">
            <img :src="fundraiserPage.logo_url" class="max-h-20 max-w-44 md:max-w-auto" :alt="fundraiserPage.title + ' logo'">
          </router-link>
        </div>
      </div>
    </tw-container-full-width>
  </div>
</template>

<style scoped>

</style>
